<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <table class="table table-basic mt-4 mb-4">
          <tr>
            <th class="w-220"><span style="color: red;">*</span>簡覆表編號</th>
            <td>
              <input
                type="text"
                maxlength="30"
                :id="`div-form_no`"
                :data-vv-name="`div-form_no`"
                placeholder="請輸入簡覆表編號"
                v-validate="'required|checkEngNum'"
                data-vv-as="簡覆表編號"
                class="form-control w-50"
                v-model="form.form_no"
                :class="{ 'is-invalid': errors.has(`div-form_no`) }"
              />
            </td>
          </tr>
          <tr>
            <th class="w-220"><span style="color: red;">*</span>遮蔽起日</th>
            <td>
              <div class="col-10 p-0">
                <select
                  :id="`start-date-year`"
                  :data-vv-name="`start-date-year`"
                  v-validate="'required|checkDateInterval|checkStartDate'"
                  data-vv-as="遮蔽起日"
                  class="form-control form-control-inline"
                  :class="{ 'is-invalid': errors.has(`start-date-year`) }"
                  v-model="form.start_date[0]"
                  @change="updateDate('start')"
                >
                  <option value>年份</option>
                  <option v-for="(opt, y_opt_i) in yearOpt" :key="`start-year-${y_opt_i}`" :value="opt"
                    >{{ opt - 1911 }}年</option
                  >
                </select>
                <span class="text">/</span>
                <select
                  :id="`start-date-month`"
                  :data-vv-name="`start-date-month`"
                  v-validate="'required|checkDateInterval|checkStartDate'"
                  data-vv-as="遮蔽起日"
                  class="form-control form-control-inline"
                  :class="{ 'is-invalid': errors.has(`start-date-month`) }"
                  v-model="form.start_date[1]"
                  @change="updateDate('start')"
                >
                  <option value>月份</option>
                  <option v-for="(opt, m_opt_i) in monthOpt" :key="`start-month-${m_opt_i}`" :value="opt"
                    >{{ opt }}月</option
                  >
                </select>
                <span class="text">/</span>
                <select
                  :id="`start-date-day`"
                  :data-vv-name="`start-date-day`"
                  v-validate="'required|checkDateInterval|checkStartDate'"
                  data-vv-as="遮蔽起日"
                  class="form-control form-control-inline"
                  :class="{ 'is-invalid': errors.has(`start-date-day`) }"
                  v-model="form.start_date[2]"
                  @change="updateDate('start')"
                >
                  <option value>日期</option>
                  <option v-for="(opt, d_opt_i) in dateOpt_start" :key="`start-date-${d_opt_i}`" :value="opt"
                    >{{ opt }}日</option
                  >
                </select>
              </div>
            </td>
          </tr>
          <tr>
            <th class="w-220"><span style="color: red;">*</span>遮蔽迄日</th>
            <td>
              <div class="col-10 p-0">
                <select
                  :id="`end-date-year`"
                  :data-vv-name="`end-date-year`"
                  v-validate="'required|checkDateInterval'"
                  data-vv-as="遮蔽迄日"
                  class="form-control form-control-inline"
                  :class="{ 'is-invalid': errors.has(`end-date-year`) }"
                  v-model="form.end_date[0]"
                  @change="updateDate('end')"
                >
                  <option value>年份</option>
                  <option v-for="(opt, y_opt_i) in yearOpt" :key="`end-year-${y_opt_i}`" :value="opt"
                    >{{ opt - 1911 }}年</option
                  >
                </select>
                <span class="text">/</span>
                <select
                  :id="`end-date-month`"
                  :data-vv-name="`end-date-month`"
                  v-validate="'required|checkDateInterval'"
                  data-vv-as="遮蔽迄日"
                  class="form-control form-control-inline"
                  :class="{ 'is-invalid': errors.has(`end-date-month`) }"
                  v-model="form.end_date[1]"
                  @change="updateDate('end')"
                >
                  <option value>月份</option>
                  <option v-for="(opt, m_opt_i) in monthOpt" :key="`end-month-${m_opt_i}`" :value="opt"
                    >{{ opt }}月</option
                  >
                </select>

                <span class="text">/</span>

                <select
                  :id="`end-date-day`"
                  :data-vv-name="`end-date-day`"
                  v-validate="'required|checkDateInterval'"
                  data-vv-as="遮蔽迄日"
                  class="form-control form-control-inline"
                  :class="{ 'is-invalid': errors.has(`end-date-day`) }"
                  v-model="form.end_date[2]"
                  @change="updateDate('end')"
                >
                  <option value>日期</option>
                  <option v-for="(opt, d_opt_i) in dateOpt_end" :key="`end_date-date-${d_opt_i}`" :value="opt"
                    >{{ opt }}日</option
                  >
                </select>
              </div>
            </td>
          </tr>
          <tr>
            <th class="w-220"><span style="color: red;">*</span>業務員ID</th>
            <td>
              <input
                type="text"
                maxlength="10"
                :id="`div-agnt_id`"
                :data-vv-name="`div-agnt_id`"
                placeholder="請輸入業務員ID"
                v-validate="'required|checkIDLength'"
                data-vv-as="業務員ID"
                class="form-control w-50"
                v-model="form.agnt_id"
                :class="{ 'is-invalid': errors.has(`div-agnt_id`) }"
                @input="checkKeyword('agnt_id')"
                @blur="checkKeyword('agnt_id')"
              />
            </td>
          </tr>
          <tr>
            <th class="w-220"><span style="color: red;">*</span>被保人ID</th>
            <td>
              <input
                type="text"
                maxlength="10"
                :id="`div-id`"
                :data-vv-name="`div-id`"
                placeholder="請輸入被保人ID"
                v-validate="'required|checkIDLength'"
                data-vv-as="被保人ID"
                class="form-control w-50"
                v-model="form.id"
                :class="{ 'is-invalid': errors.has(`div-id`) }"
                @input="checkKeyword('id')"
                @blur="checkKeyword('id')"
              />
            </td>
          </tr>
          <tr>
            <th class="w-220">備註</th>
            <td>
              <input
                type="text"
                maxlength="30"
                :id="`div-memo`"
                :data-vv-name="`div-memo`"
                placeholder="請輸入備註"
                data-vv-as="備註"
                class="form-control w-50"
                v-model="form.memo"
              />
            </td>
          </tr>
          <template v-for="(item, index) in form.policy_no">
            <tr :key="`policy_no-${index}`">
              <th class="w-220"><span style="color: red;">*</span>欲遮蔽保單號碼</th>
              <td>
                <div class="pd-0 d-flex">
                  <input
                    type="text"
                    maxlength="20"
                    :id="`div-policy_no-${index}`"
                    :data-vv-name="`div-policy_no-${index}`"
                    placeholder="請輸入欲遮蔽保單號碼"
                    v-validate="'required|checkEngNum'"
                    data-vv-as="欲遮蔽保單號碼"
                    class="form-control w-50"
                    v-model="form.policy_no[index]"
                    :class="{ 'is-invalid': errors.has(`div-policy_no-${index}`) }"
                  />
                  <a v-if="form.policy_no.length > 1" @click="removeForm(index)" class="ml-3 btn btn-default delete-btn"
                    >刪除</a
                  >
                </div>
              </td>
            </tr>
          </template>
        </table>
      </div>
      <div class="col-12">
        <div @click="addForm" class="card d-flex align-items-center justify-content-center" style="cursor: pointer;">
          <i class="icon-add_new text-orange i-32"></i>
          <p>再增加一筆</p>
        </div>
      </div>
      <div class="col-12">
        <div class="action text-right">
          <a class="btn btn-default" @click="doReset(true)">重設</a>
          <a class="btn btn-primary" @click="doSubmit">確定</a>
        </div>
      </div>
    </div>
    <!-- 打開遮罩 -->
    <mxMask :open="mxMaskOpen" :content="mxMaskContent" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { commonMixin } from '@/mixins/common';
import { Validator } from 'vee-validate';
//component
import mxMask from '@/desktop/components/mxMask';
//service
import { addPolicyCovered } from '@/service';
export default {
  name: 'policyCoveredAdd',
  mixins: [commonMixin],
  components: { mxMask },
  computed: {
    ...mapGetters(['UserInfo'])
  },
  watch: {},
  data() {
    return {
      mxMaskOpen: false,
      mxMaskContent: '資料儲存中，請稍候...',
      form: {
        form_no: '', // 簡覆表編號
        start_date: ['', '', ''], // 遮蔽起日
        end_date: ['', '', ''], // 遮蔽迄日
        agnt_id: '', // 業務員ID
        id: '', // 被保人ID
        memo: '', // 備註
        policy_no: [''] // 欲遮蔽保單號碼
      },
      yearOpt: [],
      dateOpt_start: [], //遮蔽起日日期下拉選單
      dateOpt_end: [], //遮蔽迄日日期下拉選單
      monthOpt: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
    };
  },
  mounted() {
    const thisYear = new Date().getFullYear();
    for (let i = 0; i < 3; i++) {
      this.yearOpt.push(thisYear + i);
    }
    this.initValidator();
  },
  methods: {
    ...mapActions(['setPageLock']),
    //檢核ID
    checkKeyword(id) {
      if (this.form[id]) {
        this.form[id] = this.form[id].toUpperCase();
        this.form[id] = this.form[id].replace(/[^a-zA-Z0-9]+/g, '');
      }
      if (this.stringBytes(this.form[id], false, 10) > 10) {
        this.form[id] = this.form[id].substring(0, this.stringBytes(this.form[id], true, 10));
      }
    },
    //重設
    doReset(showMsg) {
      this.form = {
        form_no: '', // 簡覆表編號
        start_date: ['', '', ''], // 遮蔽起日
        end_date: ['', '', ''], // 遮蔽迄日
        agnt_id: '', // 業務員ID
        id: '', // 被保人ID
        memo: '', // 備註
        policy_no: [''] // 欲遮蔽保單號碼
      };
      if (showMsg) {
        this.$toast.info({ title: '畫面重設成功' });
      }
    },
    //刪除該筆
    removeForm(index) {
      this.form.policy_no.splice(index, 1);
    },
    // +再增加一筆
    addForm() {
      this.form.policy_no.push('');
    },
    //起訖日期-下拉選單初始化
    updateDate(type) {
      let year = '';
      let month = '';
      if (type == 'start') {
        year = this.form.start_date[0];
        month = this.form.start_date[1];
      } else {
        year = this.form.end_date[0];
        month = this.form.end_date[1];
      }
      if (!year || !month) return;
      let dt = new Date(year, month, 0).getDate();
      if (type == 'start') {
        this.dateOpt_start = [];
        for (let i = 0; i < dt; i++) {
          this.dateOpt_start.push(i + 1);
        }
      } else {
        this.dateOpt_end = [];
        for (let i = 0; i < dt; i++) {
          this.dateOpt_end.push(i + 1);
        }
      }
    },
    doSubmit() {
      //檢核
      this.$validator.validateAll().then(el => {
        if (!el) {
          let errMsg = [];
          for (let i = 0; i < this.errors.items.length; i++) {
            errMsg.push(this.errors.items[i].msg);
          }
          let showErrMsg = [...new Set(errMsg)];
          showErrMsg.forEach(s => {
            this.$toast.info({ title: s }); //印出檢核後的錯誤訊息
          });
        } else {
          this.callApi();
        }
      });
    },
    callApi() {
      // 處理日期補到兩位數
      const startMonth =
        this.form.start_date[1].toString().length == 1 ? '0' + this.form.start_date[1] : this.form.start_date[1];
      const startDay =
        this.form.start_date[2].toString().length == 1 ? '0' + this.form.start_date[2] : this.form.start_date[2];
      const endMonth =
        this.form.end_date[1].toString().length == 1 ? '0' + this.form.end_date[1] : this.form.end_date[1];
      const endDay = this.form.end_date[2].toString().length == 1 ? '0' + this.form.end_date[2] : this.form.end_date[2];

      const reqData = {
        form_no: this.form.form_no.trim(), // 簡覆表編號
        start_date: this.form.start_date[0] + '-' + startMonth + '-' + startDay, // 遮蔽起日
        end_date: this.form.end_date[0] + '-' + endMonth + '-' + endDay, // 遮蔽迄日
        agnt_id: this.form.agnt_id.trim(), // 業務員ID
        id: this.form.id.trim(), // 被保人ID
        memo: this.form.memo, // 備註
        policy_no: [], // 欲遮蔽保單號碼
        upd_id: this.UserInfo.id // 輸入人員ID
      };
      this.form.policy_no.forEach(x => reqData.policy_no.push(x.trim()));
      this.mxMaskOpen = true;
      addPolicyCovered(this.UserInfo.id, reqData).then(result => {
        this.mxMaskOpen = false;
        if (result.header && result.header.status == '200') {
          this.$toast.info({ title: '保單遮蔽資料新增成功' });
        } else {
          this.$toast.info({ title: result.header.message });
        }
      });

      this.$validator.reset();
    },
    initValidator() {
      // 初始自訂義檢核
      Validator.extend('checkEngNum', {
        getMessage: field => {
          return `${field}不可輸入英文、數字以外內容`;
        },
        validate: value => {
          let isNonEmpty = value.trim().length > 0;
          let isFormatCurrect = /^[a-zA-Z0-9\\]*$/.test(value);
          return isNonEmpty && isFormatCurrect;
        }
      });

      // 初始自訂義檢核
      Validator.extend('checkDateInterval', {
        getMessage: () => {
          return `遮蔽日期迄日不可早於起日`;
        },
        validate: () => {
          if (
            !this.form.start_date[0] ||
            !this.form.start_date[1] ||
            !this.form.start_date[2] ||
            !this.form.end_date[0] ||
            !this.form.end_date[1] ||
            !this.form.end_date[2]
          ) {
            return true;
          }
          let startMonth =
            this.form.start_date[1].toString().length == 1
              ? "0" + this.form.start_date[1].toString()
              : this.form.start_date[1].toString();
          let startDate =
            this.form.start_date[2].toString().length == 1
              ? "0" + this.form.start_date[2].toString()
              : this.form.start_date[2].toString();
          let chk_start_date =
            this.form.start_date[0] + "-" + startMonth + "-" + startDate;

          let endMonth =
            this.form.end_date[1].toString().length == 1
              ? "0" + this.form.end_date[1].toString()
              : this.form.end_date[1].toString();
          let endDate =
            this.form.end_date[2].toString().length == 1
              ? "0" + this.form.end_date[2].toString()
              : this.form.end_date[2].toString();
          let chk_end_date =
            this.form.end_date[0] + "-" + endMonth + "-" + endDate;

          let start = new Date(chk_start_date);
          let end = new Date(chk_end_date);
          return start.getTime() <= end.getTime();
        }
      });

      // 初始自訂義檢核
      Validator.extend('checkStartDate', {
        getMessage: () => {
          return `遮蔽日期起日不可早於今日`;
        },
        validate: () => {
          if (
            !this.form.start_date[0] ||
            !this.form.start_date[1] ||
            !this.form.start_date[2]
          ) {
            return true;
          }
          let startMonth =
            this.form.start_date[1].toString().length == 1
              ? "0" + this.form.start_date[1].toString()
              : this.form.start_date[1].toString();
          let startDate =
            this.form.start_date[2].toString().length == 1
              ? "0" + this.form.start_date[2].toString()
              : this.form.start_date[2].toString();
          let chk_start_date =
            this.form.start_date[0] + "-" + startMonth + "-" + startDate;

          let dd = new Date();
          let todayStr = dd.getFullYear() + "-" + parseInt(dd.getMonth() + 1) + "-" + dd.getDate();
          let chk_today = new Date(todayStr);

          let start = new Date(chk_start_date);
          let today = new Date(chk_today);
          return today.getTime() <= start.getTime();
        }
      });

      // 初始自訂義檢核
      Validator.extend('checkIDLength', {
        getMessage: field => {
          return `${field}長度不可少於10碼`;
        },
        validate: value => {
          return value.trim().length == 10;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.card {
  margin-bottom: 10px;
  border-radius: 8px;
  padding: 10px 20px;
  border: 1px solid #989ca2;
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.15);
}
.delete-btn {
  font-size: 14px;
  padding: 5px 20px;
}
</style>
